import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";

function BlogTwo() {
  //preloader
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) {
      preloader.style.display = "none";
    }
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              News &amp; Articles
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>News &amp; Articles</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Blog Section */}
      <div className="blog-page-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 g-xl-5">
            <div className="col-12 col-md-7 col-lg-8">
              <div className="d-flex flex-column gap-5 pe-lg-5">
                {/* Blog Card */}
                <div
                  className="blog-card wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="600ms"
                >
                  <img src="assets/img/bg-img/16.jpg" alt="" />
                  <div className="blog-meta d-flex align-items-center gap-2">
                    <Link to="#">September 08, 2024</Link>
                    <div className="dot"></div>
                    <Link to="#">Family Law</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    A Guide to Practicing Law in Multiple States
                  </Link>
                  <p className="mb-5">
                    When to Use Lorem Ipsum generally, lorem ipsum is best
                    suited to keeping template fo looking bare or minimizing the
                    distractions of the draft copy. Second, use lorem ipsum if
                    you think placeholder text will distracting. in voluptate
                    velit esse.
                  </p>
                  <Link to="/blogdetails" className="btn btn-primary">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                {/* Blog Card */}
                <div
                  className="blog-card wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                >
                  <img src="assets/img/bg-img/17.jpg" alt="" />
                  <div className="blog-meta d-flex align-items-center gap-2">
                    <Link to="#">September 08, 2024</Link>
                    <div className="dot"></div>
                    <Link to="#">Family Law</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    How to Successfully Organize Your Legal Files
                  </Link>
                  <p className="mb-5">
                    When to Use Lorem Ipsum generally, lorem ipsum is best
                    suited to keeping template fo looking bare or minimizing the
                    distractions of the draft copy. Second, use lorem ipsum if
                    you think placeholder text will distracting. in voluptate
                    velit esse.
                  </p>
                  <Link to="/blogdetails" className="btn btn-primary">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                {/* Blog Card */}
                <div
                  className="blog-card wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                >
                  <img src="assets/img/bg-img/89.jpg" alt="" />
                  <div className="blog-meta d-flex align-items-center gap-2">
                    <Link to="#">September 08, 2024</Link>
                    <div className="dot"></div>
                    <Link to="#">Family Law</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    Modern Offices in The Best District in Town
                  </Link>
                  <p className="mb-5">
                    When to Use Lorem Ipsum generally, lorem ipsum is best
                    suited to keeping template fo looking bare or minimizing the
                    distractions of the draft copy. Second, use lorem ipsum if
                    you think placeholder text will distracting. in voluptate
                    velit esse.
                  </p>
                  <Link to="/blogdetails" className="btn btn-primary">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                {/* Blog Card */}
                <div
                  className="blog-card wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="800ms"
                >
                  <img src="assets/img/bg-img/90.jpg" alt="" />
                  <div className="blog-meta d-flex align-items-center gap-2">
                    <Link to="#">September 08, 2024</Link>
                    <div className="dot"></div>
                    <Link to="#">Family Law</Link>
                  </div>
                  <Link className="post-title mb-3" to="/blogdetails">
                    Quick Solutions for Worst Legal Problems
                  </Link>
                  <p className="mb-5">
                    When to Use Lorem Ipsum generally, lorem ipsum is best
                    suited to keeping template fo looking bare or minimizing the
                    distractions of the draft copy. Second, use lorem ipsum if
                    you think placeholder text will distracting. in voluptate
                    velit esse.
                  </p>
                  <Link to="/blogdetails" className="btn btn-primary">
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Read More <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

                {/* Pagination */}
                <div className="col-12">
                  <ul className="blog-pagination justify-content-start list-unstyled mt-5">
                    <li className="active">
                      <Link className="magnet-link" to="#">
                        1
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="#">
                        2
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="#">
                        3
                      </Link>
                    </li>
                    <li>
                      <Link className="magnet-link" to="#">
                        <i className="ti ti-chevron-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-5 col-lg-4">
              <div className="d-flex flex-column gap-5">
                {/* Widget */}
                <div className="blog-widget">
                  <div className="h4 mb-4">Search Here</div>
                  {/* Form */}
                  <form action="#" method="get">
                    <input
                      type="search"
                      placeholder="Search here..."
                      className="form-control"
                      name="search"
                    />
                    <button type="submit">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 21L15 15M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z"
                          stroke="#1C1D20"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </form>
                </div>

                {/* Widget */}
                <div className="blog-widget">
                  <div className="h4 mb-4">Categories</div>

                  <ul className="blog-list style-two">
                    <li>
                      <Link to="/blogone">
                        Criminal Justice
                        <span>(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogone">
                        Labor Law
                        <span>(18)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogone">
                        Cultural Schemas
                        <span>(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogone">
                        Pro Bono Work
                        <span>(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogone">
                        Legal Advise
                        <span>(11)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogone">
                        Insurance Law
                        <span>(5)</span>
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Widget */}
                <div className="blog-widget">
                  <div className="h4 mb-4">Recent Posts</div>

                  <div className="d-flex flex-column gap-4">
                    {/* Widget Blog Post */}
                    <div className="widget-blog-post">
                      <div className="blog-thumbnail">
                        <img src="assets/img/bg-img/41.jpg" alt="" />
                      </div>
                      <div className="blog-content">
                        <Link to="/blogdetails">
                          A Guide to Practicing Law in Multiple States
                        </Link>
                        <p className="mb-0">October 28, 2024</p>
                      </div>
                    </div>

                    {/* Widget Blog Post */}
                    <div className="widget-blog-post">
                      <div className="blog-thumbnail">
                        <img src="assets/img/bg-img/42.jpg" alt="" />
                      </div>
                      <div className="blog-content">
                        <Link to="/blogdetails">
                          How to Successfully Organize Your Legal Files
                        </Link>
                        <p className="mb-0">October 28, 2024</p>
                      </div>
                    </div>

                    {/* Widget Blog Post */}
                    <div className="widget-blog-post">
                      <div className="blog-thumbnail">
                        <img src="assets/img/bg-img/43.jpg" alt="" />
                      </div>
                      <div className="blog-content">
                        <Link to="/blogdetails">
                          Modern Offices in The Best District in Town
                        </Link>
                        <p className="mb-0">October 28, 2024</p>
                      </div>
                    </div>

                    {/* Widget Blog Post */}
                    <div className="widget-blog-post">
                      <div className="blog-thumbnail">
                        <img src="assets/img/bg-img/44.jpg" alt="" />
                      </div>
                      <div className="blog-content">
                        <Link to="/blogdetails">
                          Quick Solutions for Worst Legal Problems
                        </Link>
                        <p className="mb-0">October 28, 2024</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Widget */}
                <div className="blog-widget">
                  <div className="h4 mb-4">Tags</div>

                  <ul className="tag-list list-unstyled">
                    <li>
                      <Link to="#">Accident</Link>
                    </li>
                    <li>
                      <Link to="#">Consultation</Link>
                    </li>
                    <li>
                      <Link to="#">Family</Link>
                    </li>
                    <li>
                      <Link to="#">Law</Link>
                    </li>
                    <li>
                      <Link to="#">Business</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default BlogTwo;
